<template>
  <footer class="landing-footer">
    <div class="footer-links">
      <router-link to="/about">About</router-link>
      <router-link to="/how-it-works">How It Works</router-link>
      <router-link to="/methodology">Methodology</router-link>
      <router-link to="/leagues-we-cover">Leagues We Cover</router-link>
      <router-link to="/contact">Contact</router-link>
      <router-link to="/conditions/terms">Terms</router-link>
      <router-link to="/conditions/privacy-policy">Privacy Policy</router-link>
    </div>

    <button class="signature-button" type="button" @click="playSignatureAnimation">
      <span v-if="signaturePrefix" class="signature-prefix">{{ signaturePrefix }}</span>
      <span class="signature-name">{{ signatureName }}</span>
    </button>
  </footer>
</template>

<script>
export default {
  name: "AppFooter",
  data() {
    return {
      signaturePrefix: "",
      signatureName: "ek.",
      isAnimating: false,
      isRevealed: false,
      timeouts: [],
    };
  },
  beforeUnmount() {
    this.clearTimers();
  },
  methods: {
    clearTimers() {
      this.timeouts.forEach((timeoutId) => window.clearTimeout(timeoutId));
      this.timeouts = [];
    },
    queueTimeout(callback, delay) {
      const timeoutId = window.setTimeout(callback, delay);
      this.timeouts.push(timeoutId);
    },
    playSignatureAnimation() {
      if (this.isRevealed) {
        window.open("https://erdemkaratas.com", "_blank", "noopener,noreferrer");
        return;
      }

      if (this.isAnimating) {
        return;
      }

      this.clearTimers();
      this.isAnimating = true;
      this.signaturePrefix = "";
      this.signatureName = "ek.";

      const prefix = "Made with passion by ";
      const tick = 42;
      prefix.split("").forEach((character, index) => {
        this.queueTimeout(() => {
          this.signaturePrefix += character;
        }, index * tick);
      });

      const sequence = [
        "erka.",
        "erdkar.",
        "erdekara.",
        "erdemkarat",
        "erdemkarata.",
        "erdemkaratas.",
      ];

      const nameStartDelay = prefix.length * tick + tick;

      sequence.forEach((value, index) => {
        this.queueTimeout(() => {
          this.signatureName = value;
        }, nameStartDelay + index * tick);
      });

      this.queueTimeout(() => {
        this.isAnimating = false;
        this.isRevealed = true;
      }, nameStartDelay + sequence.length * tick + 120);
    },
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=League+Spartan:wght@500;700&display=swap");

.landing-footer {
  background-color: white;
  text-align: center;
  margin-top: auto;
  padding: 18px 16px 20px;
  border-top: 1px solid #ececec;
}

.footer-links {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 10px 18px;
}

.footer-links a {
  text-decoration: none;
  color: #333;
  font-size: small;
}

.footer-links a:hover {
  color: #0f4c81;
}

.signature-button {
  margin-top: 16px;
  border: none;
  background: transparent;
  color: #1a1a1a;
  cursor: pointer;
  font: inherit;
  line-height: 1.2;
  transition: opacity 0.2s ease;
}

.signature-button:hover {
  opacity: 0.8;
}

.signature-prefix {
  font-size: 0.82rem;
  font-weight: 400;
  letter-spacing: 0.01em;
  color: #4d5d6c;
}

.signature-name {
  font-family: "League Spartan", "Helvetica Neue", Arial, sans-serif;
  font-size: 1.48rem;
  font-weight: 700;
  letter-spacing: 0.02em;
}
</style>
